import './App.css';
import './index.css';
import { useState, useRef, useEffect } from 'react';
import { Autocomplete, Card, Select, MenuItem, Button, TextField, Radio, RadioGroup, Checkbox, FormControlLabel, Dialog } from '@mui/material';
import NCHeader from "./ncsbiheader.png";
import superagent from "superagent";
import ReCAPTCHA from "react-google-recaptcha";
import agencies from './Agencies';
import States from './States';
import counties from './Counties';
import ndaText from './NDA';

function App() {
  const [firstName, setFirstName] = useState('');
  const [position, setPosition] = useState('');
  const [workPhone, setWorkPhone] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('NC');
  const [county, setCounty] = useState('');
  const [lastName, setLastName] = useState('');
  const [mobilePhone, setMobilePhone] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [agency, setAgency] = useState('');
  const [agencyValue, setAgencyValue] = useState('')
  const [orgdescription, setOrgdescription] = useState('');
  const [agencyType, setAgencyType] = useState('n/a');
  const [agencyDepartment, setAgencyDepartment] = useState('');
  const [privateSector, setPrivateSector] = useState('');
  const [sme, setSME] = useState('');
  const [needs, setNeeds] = useState([]);
  const [sworn, setSworn] = useState(false);
  const [nda, setNda] = useState(false);
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState([]);

  const recaptchaRef = useRef();

  function onSubmit(e) {
    e.preventDefault();
   
    let valid = validateForm();
  
    if (valid) {
      superagent
        .post(process.env.REACT_APP_API_ROUTE_NC)  
        .send({
          first_name: firstName,
          last_name: lastName,
          work_phone: workPhone,
          mobile_phone: mobilePhone, 
          city: city, 
          county: county,
          zipcode: zipcode, 
          state: state, 
          email_address: email, 
          agency_name: agency && agency.length ? agency : agencyValue, 
          agency_type: agencyType, 
          nda: nda, 
          sworn: sworn, 
          agency_department: agencyDepartment,
          orgdescription: orgdescription,
          private_sector: privateSector,
          sme: sme,
          needs: JSON.stringify(needs),
          position: position,
          recaptcha: recaptchaRef.current.getValue()
        })
        .then(resp => window.alert('Application successfully submitted.'))
        .catch(err => console.log(err));
    }
  }

  function validateForm() {
    let errorList = errors;
    if (!nda) {
      errorList.push('You must agree to the Non-Disclosure Agreement.');
    }

    if (!recaptchaRef.current.getValue()) {
      errorList.push('Captcha is invalid.')
    }
  
    if (!firstName.length) {
      errorList.push('You must specify a first name.')
    }
  
    if (!lastName.length) {
      errorList.push('You must specify a last name.')
    }
  
    if (!position.length) {
      errorList.push('You must specify a position/rank/title.')
    }
  
    if (!workPhone.length) {
      errorList.push('You must specify a primary phone.')
    }
  
    if (!city.length) {
      errorList.push('You must specify a city.')
    }
  
    if (!county.length) {
      errorList.push('You must specify a county.')
    }
  
    if (!zipcode.length) {
      errorList.push('You must specify a zipcode.')
    }
  
    if (!email.length) {
      errorList.push('You must specify an email address.')
    }
  
    if (email !== confirmEmail) {
      errorList.push('There is a mismatch between your email and email confirmation.')
    }

    if (!orgdescription) {
      errorList.push('You must specify an organization description.');
    }
  
    //if (agency && !agency.length) {
    //  errorList.push('You must specify an agency.')
    //}

    if (!agencyType) {
      errorList.push('You must specify an agency type.')
    }

    if (errorList.length) {
      setErrors(errorList);
      setOpen(true);
    }
  
    return !errorList.length;
  }

  return (
    <div className="App">
      <Dialog width={'60%'} onClose={() => {setErrors([]); setOpen(false);}} open={open}>
        <div style={{textAlign: 'center', padding: '40px'}}>
          {errors.map((err) => 
            <p style={{color: 'red'}}>{err}</p>
          )}
        </div>
      </Dialog>
      <div className="Header">
       <img style={{width: '100%'}} src={NCHeader} alt="NC Banner"/>
      </div>
      <div id={'nc-grid'} style={{display: 'flex', alignItems: 'center', flexDirection: 'column', flexWrap: 'nowrap', gap: '10px'}}>
        <form onSubmit={onSubmit}>
        <div className='cardContainer'>
          <Card style={{textAlign: 'left', paddingLeft: '10px'}}>
            <p>Contact email address must be agency/organization affiliated and not a personal address.</p>
            <p>Please complete the form below and note that partial applications will not be submitted.</p>
          </Card>
        </div>
        <div className='cardContainer'>
          <Card>
            <div className="cardHeader">
              CONTACT INFORMATION
            </div>
            <div className="formContainer">
              <div className="formLeft">
                  <div className="formRow">
                    <b className="bold-label" style={{marginRight: '85px'}}>First Name </b>
                    <TextField id="firstName" value={firstName} onChange={(e) => setFirstName(e?.target?.value)} size={'small'} style={{width: '69%'}} className="fieldFloat"/>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{marginRight: '20px'}}>Position/Title/Rank</b>
                    <TextField id="position" value={position} onChange={(e) => setPosition(e?.target?.value)} size={'small'} style={{width: '69%'}} className="fieldFloat"/>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{marginRight: '74px'}}>Primary Phone</b>
                    <TextField id="workPhone" value={workPhone} onChange={(e) => setWorkPhone(e?.target?.value)} size={'small'} style={{width: '69%'}} className="fieldFloat"/>
                  </div>
                  <div className="formRow">
                    <b className="bold-label" style={{marginRight: '137px'}}>City</b>
                    <TextField id="city" value={city} onChange={(e) => setCity(e?.target?.value)} size={'small'} style={{width: '69%'}} className="fieldFloat"/>
                  </div>
              </div>
              <div className="formRight">
                <div className="formRow">
                  <b className="bold-label" style={{marginRight: '85px'}}>Last Name </b>
                  <TextField id="lastName" value={lastName} onChange={(e) => setLastName(e?.target?.value)} size={'small'} style={{width: '73%'}} className="fieldFloat"/>
                </div>
                <div className="formRow">
                    <b className="bold-label" style={{marginRight: '60px'}}>Alternate Phone</b>
                    <TextField id="mobilePhone" placeholder={'optional'} value={mobilePhone} onChange={(e) => setMobilePhone(e?.target?.value)} size={'small'} style={{width: '73%'}} className="fieldFloat"/>
                </div>
                <div className="formRow">
                    <b className="bold-label" style={{marginRight: '110px'}}>County</b>
                    <Autocomplete options={counties} value={county} freeSolo={true} onChange={(_, value) => {setCounty(value)}} id="county" size={'small'} style={{width: '73%', position: 'relative'}}
                    renderInput={(params) => (
                      <TextField {...params} onChange={(e) => setCounty(e?.target?.value ? '' : e.target.value)}/>
                    )}>
                </Autocomplete>
                </div>
                <div className="formRow" style={{paddingTop: '5px', top: '-5px', position: 'relative'}}>
                    <b className="bold-label" style={{marginRight: '97px'}}>Zip Code</b>
                    <TextField id="zipcode" value={zipcode} onChange={(e) => setZipcode(e?.target?.value)} size={'small'} style={{width: '73%'}} className="fieldFloat"/>
                </div>
              </div>
              <div className="formRow">
                <b className="bold-label" style={{display: 'block'}}>State</b>
                <Select value={state} onChange={(e) => setState(e?.target?.value)} id="state" size={'small'} style={{width: '69%'}} className="fieldFloat">
                  {States.map((state) => 
                    <MenuItem key={state} value={state.abbreviation}>{state.abbreviation}</MenuItem>
                  )}
                </Select>
              </div>
              <div className="formRow">
                <b className="bold-label" style={{display: 'block'}}>Email Address</b>
                <TextField id="email" value={email} onChange={(e) => setEmail(e?.target?.value)} size={'small'} style={{width: '69%'}} className="fieldFloat"/>
              </div>
              <div className="formRow">
                <b className="bold-label" style={{display: 'block'}}>Confirm Email Address</b>
                <TextField id="confirmEmail" value={confirmEmail} onChange={(e) => setConfirmEmail(e?.target?.value)} size={'small'} style={{width: '69%'}} className="fieldFloat"/>
              </div>
            </div>
          </Card>
        </div>
        <div className='cardContainer'>
          <Card>
            <div className="cardHeader">
              AGENCY / ORGANIZATION
            </div>
            <div className="formContainer">
              <div style={{width: '100%', marginTop: '10px', marginBottom: '10px'}}>
                <b className="bold-label">Agency / Organization Name</b>
                <Autocomplete options={agencies} value={agency} freeSolo={true} onChange={(_, value) => {setAgency(value)}} onInputChange={(event, newInputValue) => {setAgencyValue(newInputValue);}}id="agency" size={'small'} style={{width: '70%', left: '15%', position: 'relative'}}
                renderInput={(params) => (
                  <TextField {...params} onChange={(e) => setAgency(e?.target?.value ? '' : e.target.value)}/>
                )}>
                </Autocomplete>
              </div>
              <div style={{width: '100%', marginTop: '10px', marginBottom: '10px'}}>
                <b className="bold-label">Organization Description</b>
                <Autocomplete options={agencyOptions} value={orgdescription} freeSolo={true} onChange={(_, value) => {setOrgdescription(value)}} id="orgDescription" size={'small'} style={{width: '70%', left: '15%', position: 'relative'}}
                renderInput={(params) => (
                  <TextField {...params} onChange={(e) => setOrgdescription(e?.target?.value)}/>
                )}>
                </Autocomplete>
              </div>
              <div style={{width: '100%', marginTop: '10px', marginBottom: '10px'}}>
                <b className="bold-label">Identify your specialty, expertise, or interest</b>
                <Autocomplete multiple options={needsOptions} value={needs} freeSolo={true} onChange={(_, value) => setNeeds(value)} id="needs" size={'small'} style={{width: '70%', left: '15%', position: 'relative'}}
                renderInput={(params) => (
                  <TextField {...params}/>
                )}>
                </Autocomplete>
              </div>
              <div style={{width: '100%', marginTop: '10px', marginBottom: '10px'}}>
                  <b className="bold-label">Are you currently a Field Liaison Officer (FLO)</b>
                  <RadioGroup
                    style={{ alignContent: 'center' }}
                    value={sworn}
                    onChange={(_, val) => {setSworn(val)}}
                  >
                    <FormControlLabel value="true" control={<Radio />} label="Yes" />
                    <FormControlLabel value="false" control={<Radio />} label="No" />
                  </RadioGroup>
              </div>
            </div>
          </Card>
        </div>
        <div className='cardContainer'>
          <Card>
            <div className="cardHeader">
              NON-DISCLOSURE AGREEMENT
            </div>
            <div className="formContainer">
              <div style={{width: '100%', marginBottom: '20px'}}>
                <TextField value={ndaText} readOnly multiline minRows={12} maxRows={12} style={{width: '98%'}} />
              </div>
              <div style={{width: '100%'}}>
                <Checkbox className="fieldFloat" id="nda" value={nda} onChange={(e) => setNda(e?.target?.value ? true : false)} style={{float: 'left'}}/>
                <b className="bold-label" style={{float: 'left', paddingTop: '3px'}}>I AGREE TO THE NON-DISCLOSURE AGREEMENT</b>
              </div>
              <div style={{height: '130px', marginLeft: '12px'}}>
                <ReCAPTCHA 
                  ref={recaptchaRef}
                  sitekey={process.env.REACT_APP_RECAPTCHA}
                />
              </div>
            </div>
          </Card>
        </div>
        <div style={{width: '90%'}}>
          <Button variant="contained" type="submit" style={{width: '100px', float: 'left'}} >Submit</Button>
        </div> 
        </form>
      </div>
    </div>
  );
}

const agencyOptions = ["Law Enforcement Agency", "Intelligence Agency", "Emergency Management Agency", "Fire EMS Agency", "Other Government Agency", "Private Sector / Organization, or Public-Private Industry"]
const privateSectorOptions = ["Chemical", "Commercial", "Communications", "Critical Manufacturing", "Dams", "Defense", "Emergency Services", "Energy", "Financial", "Food and Agriculture", "Government Facility", "Healthcare and Public Health", "Information Technology", "Nuclear Reactors, Materials, and Waste", "Transportation", "Water and Wastewater"]
const needsOptions = ['Analysis (Crime, Intelligence)', 'Aviation (Drones, Airplane, Helicopter)', 'Arson', 'Bankwatch', 'Canine Detection', 'CBRNE', 'Child sexual exploitation', 'Civil Disturbance', 'Crime Scene Investigations / Forensic Analysis (includes Underwater search)', 'Criminal or Death Investigations (Polygraph)', 'Crisis Negotiation', 'Community outreach (Homeless Liaison, Resistance Education Programs)', 'Cyber', 'Executive Protection', 'Detention', 'Financial Crimes', 'Fraud / Theft / Robbery', 'Fugitive Apprehension', 'General or Specialized Instructor', 'Hazardous Devices and Explosives', 'Honor Guard', 'Human Trafficking', 'Internal Affairs / Special Investigations', 'Linguist', 'Marine (Harbor)', 'Mental Health Assistance', 'Mounted', 'Narcotics / Drug Investigations', 'NC Western NC Network', 'Organized Crime or Gangs', 'Patrol (Traffic, Bicycle, Marine, Motorcycle, DUI, Crash, Rail, Harbor)', 'Special Victims (Sexual assault, kidnapping, family violence)', 'School Safety', 'Technical Services', 'Threat Assessment', 'Special Weapons and Tactics', 'Workplace Violence', 'Other'];

export default App;
